import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=c52e0d90"
import script from "./InspectionList.vue?vue&type=script&lang=js"
export * from "./InspectionList.vue?vue&type=script&lang=js"
import style0 from "./InspectionList.vue?vue&type=style&index=0&id=c52e0d90&prod&lang=scss"
import style1 from "./InspectionList.vue?vue&type=style&index=1&id=c52e0d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports